// Shared rotating status lines for long-running planner operations (Arc solve, loot AI, etc.)

export const BASE_SOLVING_MESSAGES = [
  "Optimizing raid composition...",
  "Resolving guild drama...",
  "Arguing about Retail vs Classic...",
  "Convincing the Feral Druid to go Resto...",
  "Checking if the tanks are actually online...",
  "Running 10,000 simulations...",
  "Bribing the loot council...",
  "Calculating DKP...",
  "Finding someone to play Shaman...",
  "Herding 40 cats...",
  "Minimizing bench rage...",
  "Solving NP-hard problems...",
  "Rolling for raid spots...",
  "Negotiating with the MT's ego...",
  "Checking if anyone actually knows the tactics...",
  "Counting available Innervates...",
  "Balancing the hit cap spreadsheet...",
  "Appeasing the Warchief...",
  "Waiting for world buffs...",
  "Telling the Ret Paladin they can't tank...",
  "Assigning the Warlock summoning duty...",
  "Calculating buff stacking priority...",
  "Benching the guy with 200 ping...",
  "Deciding who gets the Thunderfury...",
  "Counting respec gold...",
  "Checking flasks and fire resist gear...",
  "Yelling at someone to turn off DBM sounds...",
  "Reminding people to read the strat guide...",
  "Finding a replacement for the guy who DCed...",
];

export const LOOT_AI_EXTRA_MESSAGES = [
  "Cross-referencing BIS lists...",
  "Weighing parse vs attendance...",
  "Checking who already won this tier...",
  "Consulting the loot spreadsheet...",
  "Debating tier token vs BiS piece...",
  "The loot council is watching.",
  "Rolling /roll internally...",
  "Scanning heat and upgrade value...",
  "Asking if it's a sidegrade or a huge upgrade...",
  "Checking soft-res conflicts...",
];

/** Arc solve overlay + loot AI advisor (reuses Arc flavor + loot-specific lines). */
export const LOOT_AI_WAIT_MESSAGES = [...BASE_SOLVING_MESSAGES, ...LOOT_AI_EXTRA_MESSAGES];

export function buildSolvingMessages(playerNames: string[]): string[] {
  const messages = [...BASE_SOLVING_MESSAGES];
  if (playerNames.length >= 2) {
    const picks = playerNames.sort(() => Math.random() - 0.5).slice(0, 6);
    picks.forEach((name) => {
      messages.push(`Checking if ${name} remembered to repair..`);
      messages.push(`Convincing ${name} to bring flasks...`);
      messages.push(`Waiting for ${name} to finish their bio break...`);
    });
  }
  return messages;
}

export function buildLootAiWaitMessages(candidateNames: string[]): string[] {
  const messages = [...LOOT_AI_WAIT_MESSAGES];
  if (candidateNames.length >= 2) {
    const picks = candidateNames.sort(() => Math.random() - 0.5).slice(0, 6);
    picks.forEach((name) => {
      messages.push(`Comparing ${name}'s BIS entry...`);
      messages.push(`Checking if ${name} already has BiS in that slot...`);
      messages.push(`Reviewing ${name}'s loot history...`);
    });
  }
  return messages;
}

export const COMMIT_MESSAGES = [
  "Get some sleep before raid night.",
  "Remember to stock up on consumables.",
  "Don't forget to enchant your gear.",
  "Time to practice your rotation.",
  "Hope someone remembered to bring food buffs.",
  "The loot council is watching.",
  "May your ping be low and your FPS high.",
];
